import * as Yup from 'yup';

export const validationschat = (nit: string | number) =>
    Yup.object({
        type_identification: Yup.string().required(
            'El tipo de identificación es obligatorio'
        ),
        identification: Yup.string()
            .required('La identificación es obligatoria')
            .matches(/^\d+$/, 'El campo debe ser numérico')
            .min(6, 'La identificación debe tener al menos 6 dígitos')
            .max(10, 'La identificación no puede tener más de 10 dígitos')
            .when('type_identification', {
                is: nit,
                then: () =>
                    Yup.string().matches(
                        /^\d{6,10}\-\d$/,
                        'El NIT debe tener entre 6 a 10 digitos, mas un guion y el dígito verificación'
                    ),
            }),
        name: Yup.string()
            .required('El nombre es obligatorio')
            .matches(/^[A-Za-z ]+$/, 'El nombre solo puede contener letras')
            .test(
                'NoNumbers',
                'El nombre no puede contener números',
                (value) => !/\d/.test(value)
            )
            .test(
                'Nospaces',
                'El nombre no puede contener solo espacios',
                (value) => value.trim().length !== 0
            ),
        surname: Yup.string()
            .required('El apellido es obligatorio')
            .matches(/^[A-Za-z ]+$/, 'El apellido solo puede contener letras')
            .test(
                'NoNumbers',
                'El apellido no puede contener números',
                (value) => !/\d/.test(value)
            )
            .test(
                'Nospaces',
                'El apellido no puede contener solo espacios',
                (value) => value.trim().length !== 0
            ),
        email: Yup.string()
            .email('El correo es inválido')
            .required('El correo es obligatorio')
            .test('Validate Email', 'El correo es inválido', (value) => {
                const re =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(value).toLowerCase());
            }),
        type_contact: Yup.string().required(
            'El tipo de contacto es obligatorio'
        ),
        acceptPolicy: Yup.boolean()
            .oneOf(
                [true],
                'Debe aceptar la política de privacidad y uso de datos personales'
            )
            .required(
                'Debe aceptar la política de privacidad y uso de datos personales'
            ),
    });

export const valuesChat = {
    type_identification: '',
    identification: '',
    name: '',
    surname: '',
    email: '',
    type_contact: '',
    acceptPolicy: false,
};
